import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { AiFillFire } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import AmenitiesService from "../../../services/AmenitiesService";
import PkgService from "../../../services/PkgService";
import httpUtil from "../../../utils/http.util";
import { ViewPkgAmenities } from "./ViewPkgAmenities";
import LangContext from "../../../context/LanguageContext";

export type AmenityResType = {
  id: string;
  amenity: string;
  amenity_icon: string;
  isHighlightEmenity?: boolean;
};

const TabAddPkgAmenites = () => {
  const [data, setData] = useState<AmenityResType[]>([]);
  const [pkgs, setPkgs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedAmenityItems, setSelectedAmenityItems] = useState<
    AmenityResType[]
  >([]);
  const [prevAddedAmenities, setPrevAddedAemnities] = useState<
    AmenityResType[]
  >([]);
  const [selectedPkg, setSelectedPkg] = useState<string>("");
  const [currentPkgId, setCurrentPkgId] = useState<string>("");
  const { lang_id } = useContext(LangContext);

  const fetchAmenities = async () => {
    try {
      const res = await AmenitiesService.getAllAmenities();
      setData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPackages = async () => {
    try {
      const res = await PkgService.AllPkges();

      setPkgs(res.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPkgAmenities = (pkg_id: string) => {
    // single pkg detials fetch huna pryo
    PkgService.PkgDetail(pkg_id, lang_id)
      .then((res) => {
        setPrevAddedAemnities(res.data.data.pkgAmenities);
      })
      .catch((err) => {
        console.log(err);
      });
    // selectedAmenities ko default value ma single pkg bata aako amenities dekhina pryo
  };
  const handlePkgSelect = (pkg_id: string) => {
    setCurrentPkgId(pkg_id);
    // select pkg dekhina pryo
    setSelectedPkg(pkg_id);
    fetchPkgAmenities(pkg_id);
    // amenities fetch huna pryo
    fetchAmenities();
  };

  const handleAmenitySelect = (
    selectedOptValue: string,
    isHighlightEmenity?: boolean
  ) => {
    if (selectedOptValue && isHighlightEmenity === true) {
      const updatedSelectedAmenity = selectedAmenityItems.map((item, i) => {
        if (item.id === selectedOptValue) {
          item.isHighlightEmenity = true;
        }
        return item;
      });
      setSelectedAmenityItems(updatedSelectedAmenity);
    } else if (selectedOptValue && isHighlightEmenity === false) {
      const updatedSelectedAmenity = selectedAmenityItems.map((item, i) => {
        if (item.id === selectedOptValue) {
          item.isHighlightEmenity = false;
        }
        return item;
      });
      setSelectedAmenityItems(updatedSelectedAmenity);
    } else {
      const [selected] = data.filter(
        (item: AmenityResType) => item.id === selectedOptValue
      );
      selected["isHighlightEmenity"] = isHighlightEmenity || false;
      setSelectedAmenityItems([...selectedAmenityItems, selected]);
      // removing selected item from amenities list
      setData((currentAmenity) =>
        currentAmenity.filter((item: AmenityResType) => item.id !== selected.id)
      );
    }
  };

  const handleRemoveSelectedAmenity = (deselectedItem: AmenityResType) => {
    setSelectedAmenityItems((current) =>
      current.filter((item, i) => item !== deselectedItem)
    );
    setData([
      ...data,
      {
        id: deselectedItem.id,
        amenity: deselectedItem.amenity,
        amenity_icon: deselectedItem.amenity_icon,
      },
    ]);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = {
        pkg: selectedPkg,
        amenities: selectedAmenityItems,
      };
      // console.log(data);
      const res = await httpUtil.post(
        `${process.env.REACT_APP_API}/pkgAmenity/create`,
        data
      );
      fetchPkgAmenities(currentPkgId);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  return (
    <div className="grid grid-cols-5 gap-8">
      <form onSubmit={handleSubmit} className="col-span-2">
        <label htmlFor="pkgs">Choose a package</label>
        <select
          name=""
          id="pkgs"
          className="form-input inputs my-4"
          onChange={(e) => handlePkgSelect(e.target.value)}
        >
          <option value="">--Select Package--</option>
          {pkgs?.map((item: any, i) => (
            <option value={item.id} key={i}>
              {item.title}
            </option>
          ))}
        </select>

        <div className="flex items-center gap-2 flex-wrap">
          {selectedAmenityItems?.map((item: AmenityResType, i) => (
            <div
              key={i}
              className="bg-gray-100 px-2 py-1 flex space-x-2 items-center cursor-pointer"
            >
              {item.isHighlightEmenity === false ? (
                <span
                  className="text-gray-400"
                  onClick={() => handleAmenitySelect(item.id, true)}
                >
                  <AiFillFire title="Select this as highlighted amenity" />
                </span>
              ) : (
                <span
                  className="text-orange-600"
                  onClick={() => handleAmenitySelect(item.id, false)}
                >
                  <AiFillFire title="Deselect this from highlighted amenity" />
                </span>
              )}
              <span>
                <img
                  src={`${process.env.REACT_APP_API}/uploads/images/${item.amenity_icon}`}
                  alt=""
                  className="h-8 w-8 object-contain mr-2"
                />
              </span>
              {item?.amenity}{" "}
              <IoClose
                onClick={(e) => handleRemoveSelectedAmenity(item)}
                className="cursor-pointer"
                title="Deselect item!"
              />
            </div>
          ))}
        </div>

        <label htmlFor="amenities">Choose amenities</label>
        <select
          name=""
          id=""
          onChange={(e) => handleAmenitySelect(e.target.value)}
          className="form-input inputs my-4"
        >
          <option value="">--select amenities--</option>
          {data?.map((item: AmenityResType, i: number) => (
            <option value={item.id} key={i}>
              <span>
                <img
                  src={`${process.env.REACT_APP_API}/uploads/images/${item.amenity_icon}`}
                  alt=""
                />
              </span>
              {item.amenity}
            </option>
          ))}
        </select>

        <div className="my-4">
          <input
            type="submit"
            value={loading ? "Loading" : "Submit"}
            disabled={loading}
            className="btn btn-primary"
          />
        </div>
      </form>

      {/* right grid  */}
      {/* TODO: update and dlt pkg amenities  */}
      {/* TODO: make this seperate component  */}
      <div className="col-span-3">
        <ViewPkgAmenities
          prevAddedAmenities={prevAddedAmenities}
          fetchPkgAmenities={() => fetchPkgAmenities(currentPkgId)}
        />
      </div>
    </div>
  );
};

export default TabAddPkgAmenites;
